import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/lib/Image';
import Utils from '../common/Utils';
import { ImageSizes, Devices } from '../common/Constants';
import Classes from '../common/Classes';

const Logo = ({ url, name, defaultLogoUrl }) => {
  const imgProps = {
    responsive: true,
    alt: name,
    title: name,
    src: defaultLogoUrl
  };
  if (!url) {
    if (!defaultLogoUrl) {
      return (<div className={Classes.profileLogo} />);
    }
    return (
      <div className={Classes.profileLogo}>
        <Image {...imgProps} />
      </div>);
  }
  const mobileAndDesktopUrl = Utils.getResizedImage(url, Devices.desktop, ImageSizes.directory);
  return (
    <div className={Classes.profileLogo}>
      <Image {...imgProps} src={mobileAndDesktopUrl} />
    </div>
  );
};

Logo.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string,
  defaultLogoUrl: PropTypes.string
};

export default Logo;
